import type {AppError} from '@packages/utils';
import type React from 'react';
import {useCallback, useState} from 'react';
import {usePutMyInterests} from '../../../../core/repositories/mypageRepository';
import {showErrorSnackBar} from '../../../../shared/components';
import {CompanyDetailInterestsPresentation} from './presentation';

type Props = {
  interestsId: number;
};

export const CompanyDetailInterestsContainer: React.FC<Props> = ({
  interestsId,
}: Props) => {
  const [youAreInterested, setYouAreInterested] = useState(false);
  const putMyInterests = usePutMyInterests({
    onSuccessFnc() {
      setYouAreInterested(true);
    },
    onErrorFnc(error: unknown) {
      const castedError = error as {message: AppError};
      showErrorSnackBar({
        isNetworkError: castedError.message === 'NetworkError',
      });
    },
  });
  const handelClickInterest = useCallback(() => {
    if (interestsId) {
      putMyInterests.mutate({status: 'agreed', interestsId});
    }
  }, [interestsId, putMyInterests.mutate]);
  return (
    <CompanyDetailInterestsPresentation
      youAreInterested={youAreInterested}
      handleClickInterest={handelClickInterest}
    />
  );
};
